export interface PromotionApplicationProps {
  appliedId: number;
  appliedAt: string;
  applicationSource: string;
}

export class PromotionApplication {
  private readonly _appliedId: number;
  private readonly _appliedAt: string;
  private readonly _applicationSource: string;

  constructor(props: PromotionApplicationProps) {
    this._appliedId = props.appliedId;
    this._appliedAt = props.appliedAt;
    this._applicationSource = props.applicationSource;
  }

  get appliedId(): number {
    return this._appliedId;
  }

  get appliedAt(): string {
    return this._appliedAt;
  }

  get applicationSource(): string {
    return this._applicationSource;
  }

  static from(props: PromotionApplicationProps): PromotionApplication {
    return new PromotionApplication(props);
  }
}
